import { Space } from 'antd';
import ReviewScoreVisualisation from './ReviewScoreVisualisation';
import React from 'react';

import './assets/reviews_header.css';

/**
 * Full width banner for a fishery with score visualisation on the left and number of reviews on the right
 */
export default function ReviewsHeader({ score, numReviews }) {
  return (
    <div className={'reviews-header mg-bottom-15'}>
      <Space direction={'horizontal'}>
        <ReviewScoreVisualisation score={score} />
        <span className={'gBold fs-18'}>{score}/5</span>
      </Space>
      <span className={'gRegular sb-blue fs-21'}>
        {numReviews} {`review${numReviews !== 1 ? 's' : ''}`}
      </span>
    </div>
  );
}
